(function () {
  function removeDisclosure(root) {
    root = root || document;

    // 1) Remove by stable id (if present)
    const btn = root.querySelector('#shopify-subscription-policy-button');
    if (btn) {
      const small = btn.closest('small');
      if (small) small.remove();
      else btn.remove();
      return;
    }

    // 2) Fallback: remove the whole sentence if it exists as plain text
    // (covers cases where the id is stripped/rewritten)
    const needles = [
      'This item is a recurring or deferred purchase',
      'authorize you to charge my payment method',
      'cancellation policy'
    ];

    const candidates = root.querySelectorAll('product-form, .product-form, form[action*="/cart/add"], .product__info-container');
    candidates.forEach((c) => {
      // Find small/p elements that contain the disclosure text
      c.querySelectorAll('small, p, div').forEach((el) => {
        const t = (el.textContent || '').trim();
        if (!t) return;
        if (needles.some(n => t.includes(n))) el.remove();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeDisclosure(document);

    // Prevent re-injection (Dawn can re-render product-form)
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node && node.nodeType === 1) removeDisclosure(node);
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
